import moment from 'moment';
import CRUDgeneric from 'utils/CRUDgeneric';
import { formatReceived } from 'utils/formatValues';

// Defino a donde el cliente consumira los enpoints.
const _cliente = CRUDgeneric('/nominas/registro-dias-guardia/');
// El nombre del modelo que aparecera al agregar y editar.
const _nameModel = 'Registro de Días de Guardia';
// El nombre del modelo para mencionar al nombre del registro.
const _nameModelSingular = 'el Registro de Día de Guardia';

// Formatea el registro antes insertarlo al form.
const _formatRecordForRead = (record) => {
  const dataFormatedById = {
    ...formatReceived(record),
    configurar_guardias_vacacionales_general: record?.configurar_guardias_vacacionales_general?.id,
    configurar_guardias_vacacionales: record?.configurar_guardias_vacacionales?.id,
    fecha_registro: record?.fecha_registro
      ? moment(record?.fecha_registro)
      : null,
    fecha_inicial: record?.fecha_inicial
      ? moment(record?.fecha_inicial)
      : null,
    fecha_final: record?.fecha_final
      ? moment(record?.fecha_final)
      : null,
    estados_globales: record?.estados_globales?.id,
  };
  return dataFormatedById;
};
// Formatea el registro antes de enviarlo al backend.
/** necesario en fechas, de lo contrario solo volver a mandar el record */
const _formatRecordForSend = (record) => {
  const _record = record;
  if (record.fecha_registro?.format) {
    _record.fecha_registro = record.fecha_registro.format('YYYY-MM-DD');
  }
  if (record.fecha_inicial?.format) {
    _record.fecha_inicial = record.fecha_inicial.format('YYYY-MM-DD');
  }
  if (record.fecha_final?.format) {
    _record.fecha_final = record.fecha_final.format('YYYY-MM-DD');
  }
  if (record.fecha_inicio_registro?.format) {
    _record.fecha_inicio_registro = record.fecha_inicio_registro.format('YYYY-MM-DD');
  }
  if (record.de_las?.format) {
    _record.de_las = record.de_las?.format('HH:mm:ss');
  }
  if (record.a_las?.format) {
    _record.a_las = record.a_las?.format('HH:mm:ss');
  }
  return _record;
};
/**
 * Creates a date-disabling function based on a date range and weekends.
 *
 * @param {moment.Moment} minDate - Minimum allowed date (inclusive).
 * @param {moment.Moment} maxDate - Maximum allowed date (inclusive).
 * @param {boolean} isByWorkingDays - check if we exclude sunday and saturday.
 * @returns {(current: moment.Moment | null) => boolean}
 * A function that returns `true` if the date should be disabled.
 */
const disabledDateByRange = (minDate, maxDate, isByWorkingDays = false) => (current) => {
  if (!current) return false;
  const isWeekend = isByWorkingDays
    ? current.day() === 0 || current.day() === 6
    : false;
  return (
    isWeekend
    || current.isBefore(minDate, 'day')
    || current.isAfter(maxDate, 'day')
  );
};

/**
 * Parameters used to handle multiple date selection logic.
 *
 * @typedef {Object} MultipleSelectParams
 * @property {moment.Moment} date
 *   The date currently being selected or interacted with.
 * @property {moment.Moment[]} selectedDates
 *   List of selected dates.
 */

/**
 * Result returned after applying the multiple selection logic.
 *
 * @typedef {Object} MultipleSelectResult
 * @property {moment.Moment[]} selectedDates
 *   Updated list of selected dates.
 */

/**
 * Handles multiple date selection behavior.
 *
 * Updates the calendar value and selected dates based on the provided
 * selection parameters.
 *
 * @param {MultipleSelectParams} params
 *   Input parameters required to compute the next selection state.
 * @returns {MultipleSelectResult}
 *   The updated calendar value and selected dates.
 */

const multipleSelect = (params) => {
  // 4. Destructure
  const {
    date,
    selectedDates,
  } = params;

  if (!date) {
    return { selectedDates };
  }

  const exists = selectedDates.some((d) => d.isSame(date, 'day'));

  const nextSelected = exists
    ? selectedDates.filter((d) => !d.isSame(date, 'day'))
    : [...selectedDates, date.clone()];

  return {
    selectedDates: nextSelected,
  };
};

export const multipleDatePicker = {
  disabledDateByRange,
  multipleSelect,
};

// Empaqueto todo en un objeto
/** permite llamarlo facilmente por el editor */
export const ModelRegistroGuardiasTable = {
  cliente: _cliente,
  nameModel: _nameModel,
  nameModelSingular: _nameModelSingular,
  formatter: { // el actor que formatea.
    formatRecordForRead: _formatRecordForRead,
    formatRecordForSend: _formatRecordForSend,
  },
};

/**
 * GET Guardias Vacacionales Periodos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getRegistroGuardiasTable = async (params) => (
  _cliente.obtenerListaDeRegistros(params)
);
